// Generates a copy-pasteable email body for a purchase order.
//
// The manager confirms an order, the email body is shown so they can
// paste it into Gmail/SMS/etc. Closes the gap between "logged in the
// app" and "supplier knows about it." Per Instructions Claude.md §5b.
//
// We deliberately keep this plain text rather than HTML — most kitchen
// managers paste into iMessage or a quick reply, not a fancy email.
import { formatMoney, formatQty } from './format.js'

export function generatePOEmail({ po, lineItems, restaurantName }) {
  const safeRestaurantName = (restaurantName || 'Our kitchen').trim()
  const supplierName = (po?.supplier_name || 'Supplier').trim()
  const dateStr = new Date(po?.created_at || po?.sent_at || Date.now())
    .toLocaleDateString('en-US', {
      weekday: 'long',
      month: 'long',
      day: 'numeric',
      year: 'numeric',
    })

  const items = (lineItems ?? []).filter((li) => Number(li?.quantity) > 0)
  const itemLines = items.map((li) => {
    // Some shapes (form line-items) use 'cost_per_unit'; recent-orders
    // nested select uses 'cost_per_unit_at_log'. Handle both.
    const perUnit = Number(li.cost_per_unit ?? li.cost_per_unit_at_log ?? 0)
    const lineTotal = Number(li.total_cost ?? perUnit * Number(li.quantity))
    const qtyStr = formatQty(li.quantity, li.unit)
    const perUnitStr = perUnit > 0 ? ` @ ${formatMoney(perUnit)}/${li.unit}` : ''
    return `  • ${li.item_name} — ${qtyStr}${perUnitStr} = ${formatMoney(lineTotal)}`
  }).join('\n')

  const total = Number(po?.total_cost ?? 0)
  const notesLine = po?.notes ? `\nNotes: ${po.notes}\n` : ''

  return `Hi ${supplierName},

Please prepare the following order for ${safeRestaurantName} (${dateStr}):

${itemLines}

Total: ${formatMoney(total)}${notesLine}
Thanks,
${safeRestaurantName} kitchen`
}
